import React from 'react'
import MasterLayout from '../masterLayout/MasterLayout'
import UserListLayer  from '../components/users/UserListLayer'

export const UserListPage = () => {
  return (
    <MasterLayout>
        <UserListLayer />
    </MasterLayout>
  )
}
